export const REVIEW_ATTACHMENT_VIDEO = 'VIDEO'
export const REVIEW_ATTACHMENT_IMAGE = 'IMAGE'
